/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
import React from "react";
import { string } from "prop-types";
import { SeIcon } from "@se/web-ui-react";

class MsxIcons extends React.Component {
  render() {
    switch (this.props.name) {
      case "share":
        return <SeIcon {...this.props}>action_share</SeIcon>;
      case "duplicate":
        return <SeIcon {...this.props}>action_duplicate</SeIcon>;
      case "other":
        return <SeIcon {...this.props}>other_plain</SeIcon>;
      case "info":
        return <SeIcon {...this.props}>information_circle</SeIcon>;
      case "info-tooltip":
        return <SeIcon {...this.props}>information_stroke</SeIcon>;
      case "alert":
        return <SeIcon {...this.props}>general_danger_wired</SeIcon>;
      case "alert-filled":
        return <SeIcon {...this.props}>general_danger_full</SeIcon>;
      case "arrow-left":
        return <SeIcon {...this.props}>arrow2_left</SeIcon>;
      case "arrow-right":
        return <SeIcon {...this.props}>arrow2_right</SeIcon>;
      case "arrow-down":
        return <SeIcon {...this.props}>arrow2_down</SeIcon>;
      case "spinner":
        return <SeIcon {...this.props}>spinner</SeIcon>;
      case "refresh":
        return <SeIcon {...this.props}>data_refresh_stroke</SeIcon>;
      case "check_filled":
        return <SeIcon {...this.props}>notification_ok_stroke</SeIcon>;
      case "alert_rounded":
        return <SeIcon {...this.props}>notification_critical_stroke</SeIcon>;
      case "info-notif":
        return <SeIcon {...this.props}>notification_critical</SeIcon>;
      case "notification_ok_wired":
        return <SeIcon {...this.props}>notification_ok_wired</SeIcon>;
      case "close":
        return <SeIcon {...this.props}>action_close</SeIcon>;
      case "add-flat":
        return <SeIcon {...this.props}>action_add_flat</SeIcon>;
      case "action_delete":
        return <SeIcon {...this.props}>action_delete</SeIcon>;
      case "action_settings":
        return <SeIcon {...this.props}>action_settings1</SeIcon>;
      case "eye_show":
        return <SeIcon {...this.props}>body_eye</SeIcon>;
      case "eye_dont_show":
        return <SeIcon {...this.props}>eye_dont_show</SeIcon>;
      case "action_delete_cross":
        return <SeIcon {...this.props}>action_delete_cross</SeIcon>;
      case "arrow4_down":
        return <SeIcon {...this.props}>arrow4_down</SeIcon>;
      case "action_remove_flat":
        return <SeIcon {...this.props}>action_remove_flat</SeIcon>;
      case "3d_viewer":
        return <SeIcon {...this.props}>3d_viewer</SeIcon>;
      case "3d_composite":
        return <SeIcon {...this.props}>3d_composite</SeIcon>;
      case "arrow_up":
        return <SeIcon {...this.props}>arrow2_up</SeIcon>;
      case "arrow_down":
        return <SeIcon {...this.props}>arrow2_down</SeIcon>;
      case "action_filter":
        return <SeIcon {...this.props}>action_filter</SeIcon>;
      case "arrow3_down":
        return <SeIcon {...this.props}>arrow3_down</SeIcon>;
      case "expand":
        return <SeIcon {...this.props}>presentation_mode</SeIcon>;
      case "link":
        return <SeIcon {...this.props}>link</SeIcon>;
      case "unlink":
        return <SeIcon {...this.props}>unlink</SeIcon>;
      case "download":
        return <SeIcon {...this.props}>action_download_stroke</SeIcon>;
      case "plus":
        return <SeIcon {...this.props}>electricity_polarity_positive_plus</SeIcon>;
      default:
    }
    return "";
  }
}

MsxIcons.propTypes = {
  name: string,
  color: string
};

MsxIcons.defaultProps = {
  name: "",
  color: ""
};

export default MsxIcons;
